type CourseWithAdditionalItems = { additionalItems?: ReadonlyArray<{ id: string }> | null } | null | undefined

// bookingData liegt in EINEM localStorage-Key und überlebt Kurswechsel sowie im Admin gelöschte Posten.
// Gültig sind nur Posten, die dieser Kurs anbietet (course.additionalItems, bei Flag aus leer); alles andere
// lehnt der Server mit PRICE_QUOTE_CHANGED ab, ohne dass der Kunde es abwählen könnte. Preview und Submit
// filtern mit derselben Regel. Angezeigte Posten bleiben immer erhalten (B-842 prüft weiter der Server).
export const keepCourseAdditionalItemIds = (ids: ReadonlyArray<string | null | undefined> | null | undefined, course: CourseWithAdditionalItems): Array<string> => {
    const offeredIds = new Set((course?.additionalItems ?? []).map((item) => item.id))

    return (ids ?? []).filter((id): id is string => typeof id === "string" && offeredIds.has(id))
}
